import {
    LANG_ES,
    langObj,
    PS_SHOPID_ES,
    PS_SHOPID_FR_42,
    PS_SHOPID_FR_71,
    PS_SHOPID_FR_72,
    PS_SHOPID_FR_73,
    PS_SHOPID_IT
} from "../../constants";

export default function getLangByShopId (shopId) {
    return langObj[shopId] ? langObj[shopId] : LANG_ES;
}

export function isSpanishUser (shopId) {
    return shopId != PS_SHOPID_FR_42 && shopId != PS_SHOPID_FR_71 && shopId != PS_SHOPID_FR_72 && shopId != PS_SHOPID_FR_73 && shopId != PS_SHOPID_IT;
}

export function isB2bUser (shopId) {
    return shopId != PS_SHOPID_ES && shopId != PS_SHOPID_FR_42 && shopId != PS_SHOPID_FR_71 && shopId != PS_SHOPID_FR_72 && shopId != PS_SHOPID_FR_73 && shopId != PS_SHOPID_IT;
}

export function isItalianUser (shopId) {
    return shopId == PS_SHOPID_IT;
}

export function isFrenchUser (shopId) {
    return shopId == PS_SHOPID_FR_42 || shopId == PS_SHOPID_FR_71 || shopId == PS_SHOPID_FR_72 || shopId == PS_SHOPID_FR_73;
}
